import {
  Button,
  Divider,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from '@chakra-ui/react';

import { Cadence } from '@/client/services/api/graphql/gql/graphql';
import { ChevronDownIcon } from '@chakra-ui/icons';
import type { FullNotificationMessage } from './AssignmentNotificationsForm';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AssignmentNotificationCadenceForm() {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<FullNotificationMessage>();

  const { cadence, totalMessages } = watch();

  const cadenceOptions = [
    { value: Cadence.Daily, label: t('notifications.cadence.daily') },
    { value: Cadence.Weekly, label: t('notifications.cadence.weekly') },
    { value: Cadence.Monthly, label: t('notifications.cadence.monthly') },
  ];

  return (
    <Stack spacing={6} marginTop={6}>
      <Stack spacing={2}>
        <Text variant="createLabel">{t('notifications.cadence.howOften')}</Text>

        <Menu>
          <MenuButton
            as={Button}
            variant="createGoldOutline"
            textAlign="left"
            rightIcon={<ChevronDownIcon />}
          >
            {cadenceOptions.find((option) => option.value === cadence)?.label}
          </MenuButton>

          <MenuList borderColor="warmNeutral.200">
            {cadenceOptions.map((option) => (
              <MenuItem key={option.value} onClick={() => setValue('cadence', option.value)}>
                {option.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Stack>

      <Stack spacing={2}>
        <Text variant="createLabel">{t('notifications.cadence.howManyOccurences')}</Text>

        <Menu>
          <MenuButton
            as={Button}
            variant="createGoldOutline"
            textAlign="left"
            rightIcon={<ChevronDownIcon />}
          >
            {totalMessages}
          </MenuButton>

          <MenuList maxHeight="200px" overflowY="auto" borderColor="warmNeutral.200">
            {Array.from({ length: 30 }, (_, i) => i + 1).map((num) => (
              <MenuItem key={num} onClick={() => setValue('totalMessages', num)}>
                {num}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Stack>

      <Divider />
    </Stack>
  );
}
